export function ContactsManager({ contacts }) {
  return (
    <div className="glass rounded-xl overflow-hidden" data-testid="contacts-manager">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10">
              <th className="text-left p-4 text-white/50 font-medium text-sm">Name</th>
              <th className="text-left p-4 text-white/50 font-medium text-sm">Email</th>
              <th className="text-left p-4 text-white/50 font-medium text-sm">Company</th>
              <th className="text-left p-4 text-white/50 font-medium text-sm">Interest</th>
              <th className="text-left p-4 text-white/50 font-medium text-sm">Message</th>
              <th className="text-left p-4 text-white/50 font-medium text-sm">Date</th>
            </tr>
          </thead>
          <tbody>
            {contacts.length === 0 ? (
              <tr>
                <td colSpan={6} className="p-8 text-center text-white/50">
                  No contact submissions yet
                </td>
              </tr>
            ) : (
              contacts.map((contact) => (
                <tr
                  key={contact.id}
                  className="border-b border-white/5 hover:bg-white/[0.02]"
                >
                  <td className="p-4 text-white">{contact.name}</td>
                  <td className="p-4">
                    <a href={`mailto:${contact.email}`} className="text-neon-cyan hover:underline">
                      {contact.email}
                    </a>
                  </td>
                  <td className="p-4 text-white/60">{contact.company || '-'}</td>
                  <td className="p-4 text-white/60 text-sm">{contact.interest || '-'}</td>
                  <td className="p-4 text-white/60 text-sm max-w-xs truncate">{contact.message}</td>
                  <td className="p-4 text-white/60 text-sm">
                    {new Date(contact.created_at).toLocaleDateString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ContactsManager;
